/**
 * @generated SignedSource<<150df8a9d89f0e79aae0e47e1ed3002a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteTeamInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteTeamMutation$variables = {
  input: DeleteTeamInput;
};
export type deleteTeamMutation$data = {
  readonly deleteTeam: {
    readonly deletedTeamId: string | null;
  } | null;
};
export type deleteTeamMutation = {
  variables: deleteTeamMutation$variables;
  response: deleteTeamMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTeamPayload",
    "kind": "LinkedField",
    "name": "deleteTeam",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedTeamId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteTeamMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteTeamMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "77efbf3c02db07e85d60e975b431fd56",
    "id": null,
    "metadata": {},
    "name": "deleteTeamMutation",
    "operationKind": "mutation",
    "text": "mutation deleteTeamMutation(\n  $input: DeleteTeamInput!\n) {\n  deleteTeam(input: $input) {\n    deletedTeamId\n  }\n}\n"
  }
};
})();

(node as any).hash = "67bb6eeff8e7e1b50a18158c63836f8e";

export default node;
